<!--
Divider Component — wraps PrimeVue Divider for separating content sections.

Use to visually split form groups, list items, or page regions.
Supports horizontal/vertical orientation and an optional centered slot
label via PrimeVue Divider's default slot.
-->

<template>
  <PrimeDivider v-bind="$attrs">
    <slot />
  </PrimeDivider>
</template>

<script setup lang="ts">
import PrimeDivider from 'primevue/divider';

defineOptions({ name: 'Divider', inheritAttrs: false });
</script>
